module.exports = __webpack_public_path__ + "img/product-atomizer-sopuria-Ubox_Upod.0607d1e4.jpg";